<template>
  <div>
    <gmap-polyline :path="routePath" :options="polylineOptions" />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "GoogleMapRoute",
  props: {
    waypoints: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      center: { lat: 0, lng: 0 },
      zoom: 10,
      routePath: [],
      polylineOptions: {
        strokeColor: "#307BDE",
        strokeOpacity: 1,
        strokeWeight: 6,
        strokeDashArray: [10, 10]
      }
    };
  },
  methods: {
    async calculateRoute() {
      const directionsService = new google.maps.DirectionsService();
      const maxWaypoints = 25;
      const waypoints = this.waypoints.map(waypoint => ({
        location: new google.maps.LatLng(waypoint.latitude, waypoint.longitude),
        stopover: true
      }));

      let routePath = [];
      let directions = [];

      for (let i = 0; i < waypoints.length; i += maxWaypoints) {
        const chunkWaypoints = waypoints.slice(i, i + maxWaypoints + 1);
        const request = {
          origin: chunkWaypoints[0].location,
          destination: chunkWaypoints[chunkWaypoints.length - 1].location,
          waypoints: chunkWaypoints.slice(1, -1),
          travelMode: google.maps.TravelMode.DRIVING
        };

        try {
          const response = await new Promise((resolve, reject) => {
            directionsService.route(request, (result, status) => {
              if (status === google.maps.DirectionsStatus.OK) {
                resolve(result);
              } else {
                reject(status);
              }
            });
          });

          const route = response.routes[0];
          routePath = routePath.concat(route.overview_path.map(point => ({
            lat: point.lat(),
            lng: point.lng()
          })));

          for (let j = 0; j < route.legs.length; j++) {
            const leg = route.legs[j];
            const direction = {
              startWaypoint: {
                index: i + j,
                latitude: leg.start_location.lat(),
                longitude: leg.start_location.lng()
              },
              endWaypoint: {
                index: i + j + 1,
                latitude: leg.end_location.lat(),
                longitude: leg.end_location.lng()
              },
              summary: {
                distance: Math.round(leg.distance.value),
                time: Math.round(leg.duration.value)
              }
            };
            directions.push(direction);
          }
        } catch (error) {
          console.error("Directions request failed:", error);
          return;
        }
      }

      this.$emit("calculateDirections", directions);
      this.routePath = routePath;
    }
  },
  mounted() {
    this.calculateRoute();
  },
  watch: {
    waypoints: {
      handler: function(newWaypoints, oldWaypoints) {
        this.calculateRoute();
      },
      deep: true
    }
  }
};
</script>
